<template>
    <div>
        <tab name="1"></tab>
        <el-alert title="目前仅支持最多2年的数据" show-icon type="warning"></el-alert>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
                    <el-date-picker
                        v-model="datetimerange"
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="注册时间"
                        end-placeholder="注册时间"
                        size="small"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        :clearable="false"
                        style="width:100%"
                        unlink-panels
                        >
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <!-- <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button> -->
                </el-col>
            </el-row>
        </div>
        <template v-if="statistics">
            <div class="page-group-title"><span>汇总统计</span></div>
            <el-card shadow="never" class="statistics-box">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num color-danger">{{statistics.totalNum}}</p><p class="color-info">新增总数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.iosNum}}</p><p class="color-info">iOS新增</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.androidNum}}</p><p class="color-info">Android新增</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.harmonyNum}}</p><p class="color-info">鸿蒙新增</p></el-col>

                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.wapNum}}</p><p class="color-info">WAPCN新增</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.wapEnNum}}</p><p class="color-info">WAPEN新增</p></el-col>
                    <!-- <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.webNum}}</p><p class="color-info">WEB新增</p></el-col> -->
                    <!-- <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.appletNum}}</p><p class="color-info">小程序新增</p></el-col> -->
					
					<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.byteAppletNum}}</p><p class="color-info">头条小程序新增</p></el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.wechatAppletNum}}</p><p class="color-info">微信小程序新增</p></el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.aliAppletNum}}</p><p class="color-info">支付宝小程序新增</p></el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.redbookletAppletNum}}</p><p class="color-info">小红书小程序新增</p></el-col>
					
                    <!-- <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.wenkeNum}}</p><p class="color-info">文客新增</p></el-col> -->
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.neteaseCloudNum}}</p><p class="color-info">网易新增</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.damaiNum}}</p><p class="color-info">大麦新增</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.qqMusicNum}}</p><p class="color-info">腾讯新增</p></el-col>
                    <!-- <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.baiduTotalNum}}</p><p class="color-info">百度新增</p></el-col> -->
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.otherNum}}</p><p class="color-info">其他新增</p></el-col>
                </el-row>
            </el-card>
            <div class="page-group-title"><span>统计列表</span></div>
        </template>
        
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="timeStr" label="日期" min-width="100"></el-table-column>
                <el-table-column prop="totalNum" label="新增总数"></el-table-column>
                <el-table-column prop="iosNum" label="iOS新增"></el-table-column>
                <el-table-column prop="androidNum" label="Android新增"></el-table-column>
                <el-table-column prop="harmonyNum" label="鸿蒙新增"></el-table-column>
                <el-table-column prop="wapNum" label="WAPCN新增"></el-table-column>
                <el-table-column prop="wapEnNum" label="WAPEN新增"></el-table-column>
                <el-table-column prop="appletNum" label="小程序新增">
					<template slot-scope="scope">
					    <p>头条小程序：{{scope.row.byteAppletNum}}</p>
					    <p>微信小程序：{{scope.row.wechatAppletNum}}</p>
					    <p>支付宝小程序：{{scope.row.aliAppletNum}}</p>
						<p>小红书小程序：{{scope.row.redbookletAppletNum}}</p>
					</template>
				</el-table-column>
                <el-table-column prop="neteaseCloudNum" label="网易新增"></el-table-column>
                <el-table-column prop="damaiNum" label="大麦新增"></el-table-column>
                <el-table-column prop="qqMusicNum" label="腾讯新增"></el-table-column>
                <el-table-column prop="otherNum" label="其他新增"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from '../components/tab';
const defaultParams = {
    pageNo:1,
    rangeStart:'',
    rangeEnd:'',
}
export default {
    components:{Tab},
    data(){
        const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' ) + ' 23:59:59';
        const startTime = this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 30), 'yyyy-MM-dd' )  + ' 00:00:00';
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            listLoading: false,    
            datetimerange: [this.$route.query.rangeStart || startTime, this.$route.query.rangeEnd || endTime],
            statistics: null
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            if( !this.datetimerange || this.datetimerange.length < 1 ){
                this.$message.error('请选择查询时间段')
                return;
            }
            const _timeRang = new Date( this.datetimerange[1] ) - new Date( this.datetimerange[0] );
            const _yearRang = parseInt(_timeRang / 24 / 3600 / 1000);
            if( _yearRang > 730 ){
                this.$message.error('目前仅支持最多2年的数据');
                return;
            }
            this.listLoading = true;
            this.params = {
                ...this.params,
                rangeStart:this.datetimerange && this.datetimerange[0] || '',
                rangeEnd:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/fans/report/new/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
            this.getStatistics();    
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        getStatistics(){
            if(!this.$utils.have('/fans/report/new/statistics')){
                return;
            }
            this.$request({
                url: "/fans/report/new/statistics",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.statistics = result;
                    } else {
                        this.$message.error(msg || "请求汇总统计失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求汇总统计错误");
                })
                .finally(() => {
                    
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>